import React from "react";
import { Chip, Paper, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import styles from "./styles";

const useStyles = makeStyles(styles);

const DisplayUserGroups = ({ userGroups }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Paper component="ul" className={classes.chipPanel}>
      {(!userGroups || userGroups.length === 0) && (
        <Chip label={t("labels.common.none")} className={classes.chip} />
      )}
      {userGroups &&
        userGroups.length > 0 &&
        userGroups.map((ug) => {
          return (
            <li key={ug}>
              <Chip label={ug} className={classes.chip} />
            </li>
          );
        })}
    </Paper>
  );
};

export default React.memo(DisplayUserGroups);
